export function buildDomLayout(config, jumpToPage) {
    const hasButtons = (config.buttons && config.buttons.length > 0) || (config.toolbarButtons && config.toolbarButtons.length > 0);
    const hasPaging = config.paging !== false;
    const hasSearching = config.searching !== false;
    const hasLengthMenu = config.lengthChange !== false;
    const hasInfo = config.info !== false;

    let top = '';
    if (hasPaging || hasSearching || hasButtons) {
        const left = hasPaging && hasLengthMenu ? "<'dt-length'l>" : '';
        const center = hasButtons ? `<"dt-toolbar-actions dt-toolbar-${config.toolbarAlign || 'center'}">` : '';
        const right = hasSearching ? "<'dt-search'f>" : '';
        const justifyClass = !left && !center && right ? 'justify-content-end' : 'justify-content-between';
        top = `<'dt-core-controls d-flex ${justifyClass} align-items-center'${left}${center}${right}>`;
    }

    let bottom = '';
    if (hasPaging || hasInfo) {
        const infoHtml = hasInfo ? "<'dt-info'i>" : '';
        const pagingHtml = hasPaging ? "<'dt-pagination'p>" : '';
        const jumpHtml = hasPaging && jumpToPage ? "<'dt-jump-to-page'>" : '';

        if (hasPaging && hasInfo) {
            bottom = `<'dt-core-footer d-flex justify-content-between align-items-center'${infoHtml}${jumpHtml}${pagingHtml}>`;
        } else {
            bottom = `<'dt-core-footer d-flex justify-content-end align-items-center'${infoHtml}${jumpHtml}${pagingHtml}>`;
        }
    }

    const tableContainer = config.scrollY ? 'tr' : "<'table-responsive'tr>";
    return `${top}${tableContainer}${bottom}`;
}
